import {
  CreateDistDto,
  IRequestConfig,
  IRequestOptions,
  ShApiResponse_Boolean,
  ShApiResponse_GetDistributorDto,
  ShApiResponse_GetUserPermissionsDto,
  ShApiResponse_IEnumerable_GetDistributorDto,
  ShApiResponse_List_GetDistributorDto,
  ShApiResponse_Tree_GetDistributorDto,
  ShApiResponse_ProEntitiesTree,
  UpdateDistDto,
  axios,
  basePath,
  getConfigs,
} from "./index.defs";

export class DistributorsApiService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   * Gets the distributor of the autheticated user
   */
  static distributorsGetDistributor(
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetDistributorDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/distributors";

      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Creates a distributor
   */
  static distributorsCreateDistributor(
    params: {
      /**  */
      distributorDto: CreateDistDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetDistributorDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/distributors";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = params["distributorDto"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Gets the distributor with the given id
   */
  static distributorsGetDistributorById(
    params: {
      /**  */
      distId: number;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetDistributorDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/distributors/{distId}";
      url = url.replace("{distId}", params["distId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Updates the distributor with the given id
   */
  static distributorsUpdateDistributor(
    params: {
      /**  */
      distId: number;
      /**  */
      distributorDto: UpdateDistDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetDistributorDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/distributors/{distId}";
      url = url.replace("{distId}", params["distId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "put",
        "application/json",
        url,
        options
      );

      let data = params["distributorDto"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Deletes the distributor with the given id
   */
  static distributorsDeleteDistributor(
    params: {
      /**  */
      distId: number;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/distributors/{distId}";
      url = url.replace("{distId}", params["distId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "delete",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Gets all entities in a tree structure
   */
  static distributorsGetOrganizationTree(
    params: {
      /**  */
      distId: number;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Tree_GetDistributorDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/distributors/{distId}/tree";
      url = url.replace("{distId}", params["distId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Gets all patient entities as a flat list (sub-distributors) under the distriubtor with the given id
   */
  static distributorsGetPatientEntities(
    params: {
      /**  */
      distId: number;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_List_GetDistributorDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/distributors/{distId}/entities/patient";
      url = url.replace("{distId}", params["distId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Gets all professional entities as a tree under the distriubtor with the given id
   */
  static distributorsGetProfessionalEntities(
    params: {
      /**  */
      distId: number;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_ProEntitiesTree> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/distributors/{distId}/entities/pro";
      url = url.replace("{distId}", params["distId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Gets all entities as a flat list (sub-distributors) under the distriubtor with the given id
   */
  static distributorsGetEntities(
    params: {
      /**  */
      distId: number;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_IEnumerable_GetDistributorDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/distributors/{distId}/entities";
      url = url.replace("{distId}", params["distId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Returns default permissions' values for the given role and are they allowed to change
   */
  static distributorsGetRolePermissions(
    params: {
      /** The distributor in which the new user will be created */
      distId: number;
      /** The role the new user will have */
      roleId: number;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetUserPermissionsDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/distributors/{distId}/users/permissions";
      url = url.replace("{distId}", params["distId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );
      configs.params = { roleId: params["roleId"] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
